import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const RekomendasiCTA = ({ setMenu }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box>
      <Stack direction="column" spacing={1}>
        <Typography sx={{ color: theme.palette.primary.main }} variant="body2">
          Silakan pilih nomor rekomendasi dan buat permohonan. Jika Anda belum memiliki nomor
          rekomendasi, harap melakukan pengajuan rekomendasi terlebih dahulu.
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: theme.palette.primary.main }}
          style={{ fontWeight: 'bold', cursor: 'pointer' }}
          onClick={() =>
            setMenu
              ? setMenu({ id: 'rekomendasi', name: 'Rekomendasi' })
              : navigate('/dashboard/requests')
          }
        >
          Klik disini untuk mengajukan rekomendasi.
        </Typography>
      </Stack>
    </Box>
  );
};

export default RekomendasiCTA;
